import { render, staticRenderFns } from "./RenderItem.vue?vue&type=template&id=680d5850&scoped=true"
import script from "./RenderItem.vue?vue&type=script&lang=js"
export * from "./RenderItem.vue?vue&type=script&lang=js"
import style0 from "./RenderItem.vue?vue&type=style&index=0&id=680d5850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d5850",
  null
  
)

export default component.exports